export default __webpack_public_path__ + "static/media/audio.b09f26ac.mp3";